import { render, staticRenderFns } from "./ArticleEditForm.vue?vue&type=template&id=276413c6&"
import script from "./ArticleEditForm.vue?vue&type=script&lang=js&"
export * from "./ArticleEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports